/***************************************************************
5/27/2017
Alexander Self
Timesheet modal table
- Table Summary of timesheet to be submitted for review;
***************************************************************/
import React from 'react';

const TimesheetEmployeeTable = ({ timesheet, employees }) => {
  return (
    <table className="highlight bordered responsive-table centered">
      <thead>
        <tr>
          <th>Name</th>
          <th>Grade</th>
          <th>Regular Hours</th>
          <th>Overtime</th>
          <th>Doubletime</th>
          <th>Summary of Hours</th>
          { timesheet.dustPay ? <th className="error">Dust Pay</th> : <th></th> }
        </tr>
      </thead>
      <tbody>
        {
          employees.map((e) => (
            <tr key={e.eid}>
              <td>{ e.firstName } { e.lastName }</td>
              <td>{ e.grade }</td>
              <td>{ timesheet.regHours }</td>
              <td>{ timesheet.otHours }</td>
              <td>{ timesheet.doubleTime }</td>
              <td>{ timesheet.summaryOfHours }</td>
              { timesheet.dustPay ? <td><i className="material-icons">done</i></td> : <td></td> }
            </tr>
          ))
        }
      </tbody>
    </table>
  );
};

export default TimesheetEmployeeTable;



// WEBPACK FOOTER //
// ./src/components/timesheets/create/timesheet_modal_emp_table.js